/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planner_ChangeInputs */

const en_planner_change = /** @type {(inputs: Planner_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change`)
};

const de_planner_change = /** @type {(inputs: Planner_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändern`)
};

/**
* | output |
* | --- |
* | "Change" |
*
* @param {Planner_ChangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const planner_change = /** @type {((inputs?: Planner_ChangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planner_ChangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_planner_change(inputs)
	return en_planner_change(inputs)
});